import { render, staticRenderFns } from "./salesCategory.vue?vue&type=template&id=22c2415b&scoped=true&"
import script from "./salesCategory.vue?vue&type=script&lang=js&"
export * from "./salesCategory.vue?vue&type=script&lang=js&"
import style0 from "./salesCategory.vue?vue&type=style&index=0&id=22c2415b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2415b",
  null
  
)

export default component.exports